<template>
  <basic-container>
    <div style="margin-bottom: 1rem">
      可根据工单状态设置超时提醒
    </div>
    <el-table :data="tableData" align="center">
      <!-- <el-table-column type="index" label="序号" width="50"> </el-table-column> -->
      <el-table-column label="工单状态">
        <template slot-scope="scope">
          <span>{{ getOrderStatusName(scope.row.workStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="超时设置">
        <template slot-scope="scope">
          <!-- <span v-html="getOrderSettingFlow(scope.row.workStatus,scope.row)"></span> -->
          <!-- <span v-if="parseInt(scope.row.workStatus)==0">
            新增超过<el-input maxlength="5" name="timeOut" v-model="scope.row.timeoutSetting" style="width:4rem;"></el-input>分钟，还没有进行审批操作
          </span> -->
          <span v-if="parseInt(scope.row.workStatus)==1">
            工单待指派状态，超过<el-input maxlength="5" name="timeOut" v-model="scope.row.timeoutSetting" style="width:4rem;"></el-input>分钟，还没有进行派单/抢单操作
          </span>
          <span v-if="parseInt(scope.row.workStatus)==2">
            工单已指派状态，超过<el-input maxlength="5" name="timeOut" v-model="scope.row.timeoutSetting" style="width:4rem;"></el-input>分钟，还没有进行接受/转办/协同操作
          </span>
          <span v-if="parseInt(scope.row.workStatus)==3">
            工单已接受状态，超过<el-input maxlength="5" name="timeOut" v-model="scope.row.timeoutSetting" style="width:4rem;"></el-input>分钟，还没有进行开始/转办/协同操作
          </span>
          <span v-if="parseInt(scope.row.workStatus)==4">
            工单进行中状态，超过<el-input maxlength="5" name="timeOut" v-model="scope.row.timeoutSetting" style="width:4rem;"></el-input>分钟，还没有进行完成/转办/协同/挂起/外委操作
          </span>
          <span v-if="parseInt(scope.row.workStatus)==5">
            <!-- 工单挂起状态，超过<el-input maxlength="5" name="timeOut" v-model="scope.row.timeoutSetting" style="width:4rem;"></el-input>分钟，还没有进行恢复操作 -->
            挂起超时时间由工单执行人填写
          </span>
          <span v-if="parseInt(scope.row.workStatus)==6">
            工单待验收状态，超过<el-input maxlength="5" name="timeOut" v-model="scope.row.timeoutSetting" style="width:4rem;"></el-input>分钟，还没有进行验收操作
          </span>
          <span v-if="parseInt(scope.row.workStatus)==7">
            工单执行人完成工单，状态为【已完成】
          </span>
          <span v-if="parseInt(scope.row.workStatus)==8">
            工单闭环，状态为【已关闭】
          </span>
          <span v-if="parseInt(scope.row.workStatus)==9">
            如果完成前工单被取消，状态为【已取消】
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="超时设置(分钟)">
        <template slot-scope="scope">
          <span v-if="scope.row.workStatus==5">{{"挂起超时时间由工单执行人填写"}}</span>
          <el-input
            @blur="validTimeoutNumber"
            type="text"
            maxlength="4"
            :disabled="scope.row.workStatus==5"
            v-model="scope.row.timeoutSetting"
            valid="timeoutSetting"
            v-if="getTimeoutShow(scope.row.workStatus)"
          ></el-input>
        </template>
      </el-table-column> -->
      <el-table-column label="可操作">
        <template slot-scope="scope">
          <el-input
            type="text"
            disabled="true"
            v-model="scope.row.flowActions"
          ></el-input>
          <!--{{scope.row.flowActions}}-->
          <!--<el-select v-model="scope.row.action">
              <el-option
                  v-for="item in scope.row.flowActionsList"
                  :key="item.val"
                  :label="item.val"
                  :value="item.val">
              </el-option>
          </el-select>-->
        </template>
      </el-table-column>
      <!-- <el-table-column
          label="启用/禁用"
          >
          <el-switch></el-switch>
      </el-table-column> -->
    </el-table>
    <div style="padding-bottom: 1rem; padding-top: 1rem">
      通知方式:
      <el-select
        v-model="OrderSettingFlowForm.systemNotifyWays_"
        ref="systemNotifyWays"
        name="systemNotifyWays"
        multiple
      >
        <el-option
          v-for="(item, index) in systemNotifyWaysList"
          :key="index"
          :label="item.dictValue"
          :value="item.dictKey"
        ></el-option>
      </el-select>
      工单超时后提醒干系人(执行人、协同人、创建人)及
      <!-- <el-select style="display:inline-block;width:500px;" v-model="OrderSettingFlowForm.timeoutNotifyIds">
        <el-option
          v-for="item in handlerList"
          :key="item.dictValue"
          :label="item.dictValue"
          :value="item.dictKey">
        </el-option>
      </el-select> -->
      <el-input
        valid="timeoutUserNames"
        validLabel="相关人员"
        readonly
        v-model="timeoutUserNames"
        style="display: inline-block; width: 450px"
      ></el-input>
      <el-input
        v-model="OrderSettingFlowForm.timeoutNotifyIds"
        style="display: none; width: 100px"
      ></el-input>
      <el-button @click="addUserBox">请选择</el-button>
      超时
      <el-select
        valid="timeoutNotifyStrategy"
        validLabel="超时提醒策略"
        style="display: inline-block; width: 70px"
        v-model="OrderSettingFlowForm.timeoutNotifyStrategy"
      >
        <el-option
          v-for="item in timeoutNotifyStrategyList"
          :key="item.dictValue"
          :label="item.dictValue"
          :value="item.dictKey"
        >
        </el-option>
      </el-select>
      <el-input
        type="text"
        valid="timeoutNotifyRadius"
        validLabel="超时提醒时间"
        style="display: inline-block; width: 100px"
        v-model="OrderSettingFlowForm.timeoutNotifyRadius"
        maxlength="3"
      ></el-input>
      分钟发出提醒
    </div>
    <div>
      工单完成后
      <el-input
        type="text"
        valid="evaluateTimeoutNum"
        validLabel="评价时间"
        maxlength="3"
        style="display: inline-block; width: 100px"
        v-model="OrderSettingFlowForm.evaluateTimeoutNum"
      ></el-input>
      小时未评价做
      <el-select
        valid="evaluateDefaultScore"
        validLabel="默认评价星级"
        style="display: inline-block; width: 70px"
        v-model="OrderSettingFlowForm.evaluateDefaultScore"
      >
        <el-option
          v-for="item in orderScoreList"
          :key="item.dictValue"
          :label="item.dictValue"
          :value="item.dictKey"
        >
        </el-option>
      </el-select>
      星处理，评价低于
      <el-select
        style="display: inline-block; width: 70px"
        validLabel="评价最低星级"
        valid="evaluateReturnVisitScore"
        v-model="OrderSettingFlowForm.evaluateReturnVisitScore"
      >
        <el-option
          v-for="item in orderScoreList"
          :key="item.dictValue"
          :label="item.dictValue"
          :value="item.dictKey"
        >
        </el-option>
      </el-select>
      星标记为”不合格“工单,通知方式：
       <el-select
        v-model="OrderSettingFlowForm.evaluateNotifyWays_"
        ref="systemNotifyWays"
        name="systemNotifyWays"
        multiple
      >
        <el-option
          v-for="(item, index) in systemNotifyWaysList"
          :key="index"
          :label="item.dictValue"
          :value="item.dictKey"
        ></el-option>
      </el-select>
      提醒干系人(执行人、协同人、创建人)及
      <choicePeople ref="transformPeopleRef"   :option="choicePeopleOption" @getPeople="transformGetPeople" />
    </div>
     <!-- v-if="showArriveTimeOutFlag" -->
    <div v-if="showArriveTimeOutFlag">
      <h3>工单到场超时层级推送设置</h3>
      <div>
        <el-button type="primary" @click="addNotifyLevel">新增</el-button>
      </div>
      <div
        v-for="(item, index) in notifyLevelList"
        :key="index"
        style="padding-top: 1rem"
      >
        <!-- <el-dialog
            title="请选择人员"
            :visible.sync="item.dialogUserEditBoxVisible"
            fullscreen
            append-to-body
        >
            <user-edit-box v-if="item.dialogUserEditBoxVisible" :remainUserListInside.sync="item.remainUserList" @closeAction="handleCloseAction" @submitAction="handleSubmitAction" @editAction="handleEditAction" :selectType="selectUserType" :handleAction="handleAction" :projectId="tempProjectId"/>




        </el-dialog> -->

        <el-input
          valid="timeoutUserNames"
          validLabel="相关人员"
          readonly
          v-model="item.timeoutUserNames"
          style="display: inline-block; width: 350px"
        ></el-input>
        <el-input
          v-model="item.timeoutNotifyUsers"
          style="display: none; width: 100px"
        ></el-input>
        <el-button @click="addUserBox_(item, index)">请选择</el-button>
        超时
        <el-select
          valid="timeoutNotifyStrategy"
          validLabel="超时提醒策略"
          style="display: inline-block; width: 70px"
          v-model="item.timeoutStrategy"
        >
          <el-option
            v-for="item in timeoutNotifyStrategyList"
            :key="item.dictValue"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
        <el-input
          type="text"
          valid="timeoutRadius"
          validLabel="超时提醒时间"
          style="display: inline-block; width: 100px"
          v-model="item.timeoutRadius"
          maxlength="3"
        ></el-input>
        分钟发出提醒,提醒方式
        <el-select
          v-model="item.timeoutNotifyWays_"
          @change="changeTimeoutNotifyWays(item.timeoutNotifyWays_, index)"
          ref="systemNotifyWays"
          name="systemNotifyWays"
          multiple
        >
          <el-option
            v-for="(item, index) in systemNotifyWaysList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          ></el-option>
        </el-select>
        <el-button type="danger" @click="delNotifyLevel(index)">
          删除
        </el-button>
      </div>
    </div>

    <div>
      <h3>工单备注模板</h3>
      <div>
        启用工单备注模板后，用户可以在工单中添加备注时从模板库中选择内容快捷输入。
        <el-switch
          v-model="OrderSettingFlowForm.remarkTemplateFlag_"
          active-text="启用"
          inactive-text="禁用"
        ></el-switch>
      </div>
      <div>
        <h3>填写备注时，自动获取用户位置</h3>
        <div>
          启用时，在移动端填写备注时，系统自动获取用户当前所在位置
          <el-switch
            v-model="OrderSettingFlowForm.positionFlag_"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      </div>

      <div>
        <h3>工单完成是否需要验收</h3>
        <div>
          启用时，工单完成是否需要验收
          <el-switch
            v-model="OrderSettingFlowForm.finishConfirmFlag_"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
         <div  v-show="OrderSettingFlowForm.finishConfirmFlag_" style="display: inline-block;margin-left:10px">
             验收期限
          <el-input style="width:6rem;"  maxlength="10"
            v-model="OrderSettingFlowForm.autoConfirmDays"></el-input>
          天，系统将自动完成验收。
         </div>
        </div>
      </div>

      <div>
        <h3>工单取消是否需要确认</h3>
        <div>
          启用时，工单取消是否需要确认
          <el-switch
            v-model="OrderSettingFlowForm.cancelConfirmFlag_"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      </div>


      <div>
        <h3>工单是否启用到场时间设定</h3>
        <div>
          启用时，到场时间要求需要填写
          <el-switch
            v-model="OrderSettingFlowForm.startTimeFlag_"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
         <div v-show="OrderSettingFlowForm.startTimeFlag_" style="display: inline-block;margin-left:10px;">
            到场时间要求
          <el-input style="width:3rem;"
            valid="defaultStartDelay"
          validLabel="到场时间要求" v-model="OrderSettingFlowForm.defaultStartDelay"></el-input>
          分钟
         </div>
        </div>
      </div>

      <!-- <div>
        <h3>工单回访设置</h3>
        <div>
          启用时，显示待回访的不合格工单
          <el-switch
            v-model="OrderSettingFlowForm.returnVisitFlag_"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
         
        </div>
      </div> -->
      <!--<div>
        <h3>抢单最大工单数设置</h3>
        <div>
          当前时间未完成工单大于等于
          <el-input
            type="text"
            valid="grabSingleMaxNum"
            validLabel="抢单数"
            maxlength="3"
            style="display: inline-block; width: 100px"
            v-model="OrderSettingFlowForm.grabSingleMaxNum"
          ></el-input>
          时，不能进行抢单
        </div>
      </div>-->

        <div>
        <h3>跨部门报单设置</h3>
        <div>
          启用时，允许其他部门报单
          <el-switch
            v-model="OrderSettingFlowForm.crossDeptOrderFlag_"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
      
        </div>
        <div v-if="OrderSettingFlowForm.crossDeptOrderFlag_">
          启用时，需要部门主管审批
          <el-switch
            v-model="OrderSettingFlowForm.crossDeptOrderAuditFlag_"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
      
        </div>
      </div>


      <div>
        <h3>审核提醒设置</h3>
        <div style="display: table; width: 100%">
          <div style="display: table-row">
            <div
              style="display: table-cell; padding: 1rem 0; font-weight: bold"
            >
              提醒类型
            </div>
            <div
              style="display: table-cell; padding: 1rem 0; font-weight: bold"
            >
              是否提醒
            </div>
            <div
              style="display: table-cell; padding: 1rem 0; font-weight: bold"
            >
              提醒对象
            </div>
            <div
              style="display: table-cell; padding: 1rem 0; font-weight: bold"
            >
              提醒时间
            </div>
            <div
              style="display: table-cell; padding: 1rem 0; font-weight: bold"
            >
              系统提醒
            </div>
            <div
              style="display: table-cell; padding: 1rem 0; font-weight: bold"
            >
              微信提醒
            </div>
            <div
              style="display: table-cell; padding: 1rem 0; font-weight: bold"
            >
              短信提醒
            </div>
          </div>
          <div style="display: table-row">
            <div style="display: table-cell; padding: 1rem 0">审批通知</div>
            <div style="display: table-cell; padding: 1rem 0">
              <!-- @change="updateRow(scope.row,3)" -->
              <el-switch v-model="OrderSettingFlowForm.auditNotifyFlag_">
              </el-switch>
            </div>
            <div style="display: table-cell; padding: 1rem 0">审批人</div>
            <div style="display: table-cell; padding: 1rem 0">实时推送</div>
            <div style="display: table-cell; padding: 1rem 0">
              <el-switch v-model="OrderSettingFlowForm.sys"> </el-switch>
            </div>
            <div style="display: table-cell; padding: 1rem 0">
              <el-switch v-model="OrderSettingFlowForm.wx"> </el-switch>
            </div>
            <div style="display: table-cell; padding: 1rem 0">
              <el-switch v-model="OrderSettingFlowForm.text"> </el-switch>
            </div>
          </div>

          <div style="display: table-row">
            <div style="display: table-cell; padding: 1rem 0">审批结果通知</div>
            <div style="display: table-cell; padding: 1rem 0">
              <!-- @change="updateRow(scope.row,3)" -->
              <el-switch v-model="OrderSettingFlowForm.auditResultNotifyFlag_">
              </el-switch>
            </div>
            <div style="display: table-cell; padding: 1rem 0">提交人</div>
            <div style="display: table-cell; padding: 1rem 0">实时推送</div>
            <div style="display: table-cell; padding: 1rem 0">
              <el-switch v-model="OrderSettingFlowForm.sys_"> </el-switch>
            </div>
            <div style="display: table-cell; padding: 1rem 0">
              <el-switch v-model="OrderSettingFlowForm.wx_"> </el-switch>
            </div>
            <div style="display: table-cell; padding: 1rem 0">
              <el-switch v-model="OrderSettingFlowForm.text_"> </el-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: right; padding: 2rem 0">
      <el-button type="primary" @click.native="submitAllFlowData" icon="el-icon-circle-plus-outline"
        >保存</el-button
      >
      <el-button icon="el-icon-circle-close" @click.native="closeDialog">取消</el-button>
    </div>
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      append-to-body
      @close="closeUserDialog"
      width="80%"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible"
        :remainUserListInside.sync="remainUserList"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType="selectUserType"
        :handleAction="handleAction"
        :projectId="tempProjectId"
      />
    </el-dialog>
  </basic-container>
</template>

<script>
// import {
//         getDepartmentTreeList,
//         getUserListByDepartmentId,
//         getGroupList,
//         getPrincipalUserList,
//         getMenberUserList,
//         } from "@/api/crmedical/group/group";

import { getDictionary } from "@/api/v4ward/ordersetting/action/ordersettingaction";
import { getUserListByDepartmentId } from "@/api/crmedical/group/group";
import userEditBox from "@/views/crmedical/group/user-edit-box";
import { saveOrderSettingFlow } from "@/api/v4ward/ordersetting/setting/ordersetting";
import {
  getOrderFLowDetail,
  getTimeoutNotifyStrategy,
  getOrderScoreList,
} from "@/api/order-settings/order-setting";
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue';
export default {
  props: ["flowid", "projectId"],
  components: {
    userEditBox,choicePeople
  },
  watch:{
   'OrderSettingFlowForm.autoConfirmDays': {
      handler: function(val) {
        console.log('OrderSettingFlowForm.autoConfirmDays===>',val);
        val=(val+"").replace(/^[^\d]+/g,'')
        this.OrderSettingFlowForm.autoConfirmDays = val
        }


   }
  },
  data() {
    return {
       choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'unlimitPeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 20,
      },
      showArriveTimeOutFlag:false,
      dialogIndex: "",
      AllUserList: [],
      systemNotifyWaysList: [],
      remainUserList: [],
      timeoutUserNames: "",
      handleAction: "",
      selectUserType: "",
      tempProjectId: "",
      dialogUserEditBoxVisible: false,
      /* editRemarkTemplateRow: {},
        addRemarkContent: '',
        editRemarkContent: '',
        editRemarkTemplateVisible: false,
        addRemarkTemplateVisible: false,
        remarkTemplateList: [],*/
      orderItemList: [],
      OrderSettingFlowForm: {
        timeoutNotifyStrategy: "",
        timeoutNotifyIds: "",
        evaluateTimeoutNum: "",
        grabSingleMaxNum: "",
        evaluateDefaultScore: "",
        evaluateReturnVisitScore: "",
        remarkTemplateFlag: "",
        remarkTemplateFlag_: "",
        positionFlag_: "",
        positionFlag: "",
        finishConfirmFlag: "",
        finishConfirmFlag_: "",
        autoConfirmDays:"",
        cancelConfirmFlag: "",
        cancelConfirmFlag_: "",
        startTimeFlag_:'',
        startTimeFlag:''
      },
      orderScoreList: [],
      /*handlerList: [
          {
            dictKey: '666666',
            dictValue: 'adawd'
          },
          {
            dictKey: '888888',
            dictValue: 'adawd555'
          },
        ],*/
      timeoutNotifyStrategyList: [],
      switchValue: false,
      locationValue: false,
      tableData: [],
      notifyLevelList: [],
    };
  },
  mounted() {},
  created() {
    this.choicePeopleOption.projectId = this.projectId
    getDictionary({ code: "system_notify_way" }).then((res) => {
      this.systemNotifyWaysList = res.data;
    });
    getOrderFLowDetail(this.flowid).then((res) => {
      // if (
      //   res.data.data.notifyLevelList &&
      //   res.data.data.notifyLevelList.length > 0
      // ) {
        this.notifyLevelList = res.data.data.notifyLevelList;
        this.notifyLevelList.forEach((ele, index) => {
          this.notifyLevelList[index].timeoutStrategy =
            ele.timeoutStrategy + "";
          this.notifyLevelList[index].dialogUserEditBoxVisible = false;
        });
        this.handelTableUsers(this.notifyLevelList);
        this.handelNotifyWays(this.notifyLevelList);
      // }

      console.log(res);
      this.OrderSettingFlowForm = res.data.data;
      console.log(this.OrderSettingFlowForm.flowInfoMap);
      this.OrderSettingFlowForm.auditNotifyFlag_ = this.transferBoolean(
        this.OrderSettingFlowForm.auditNotifyFlag
      );
      this.OrderSettingFlowForm.wx = this.getWx(
        this.OrderSettingFlowForm.auditNotifyWays
      );
      this.OrderSettingFlowForm.sys = this.getSys(
        this.OrderSettingFlowForm.auditNotifyWays
      );
      this.OrderSettingFlowForm.text = this.getText(
        this.OrderSettingFlowForm.auditNotifyWays
      );

      this.OrderSettingFlowForm.auditResultNotifyFlag_ = this.transferBoolean(
        this.OrderSettingFlowForm.auditResultNotifyFlag
      );
      this.OrderSettingFlowForm.wx_ = this.getWx(
        this.OrderSettingFlowForm.auditResultNotifyWays
      );
      this.OrderSettingFlowForm.sys_ = this.getSys(
        this.OrderSettingFlowForm.auditResultNotifyWays
      );
      this.OrderSettingFlowForm.text_ = this.getText(
        this.OrderSettingFlowForm.auditResultNotifyWays
      );

      if (this.OrderSettingFlowForm.systemNotifyWays) {
        this.OrderSettingFlowForm.systemNotifyWays_ = this.OrderSettingFlowForm.systemNotifyWays.split(
          ","
        );
      }
      if (this.OrderSettingFlowForm.evaluateNotifyWays) {
        this.OrderSettingFlowForm.evaluateNotifyWays_ = this.OrderSettingFlowForm.evaluateNotifyWays.split(
          ","
        );
      }
      if (this.OrderSettingFlowForm.timeoutNotifyIds.length > 0) {
        let timeoutIds = [];
        timeoutIds = this.OrderSettingFlowForm.timeoutNotifyIds.split(",");

        getUserListByDepartmentId({
          realName: this.realName,
          phone: this.phone,
        }).then((res) => {
          console.log("res getUserListByDepartmentId==>", res);
          this.AllUserList = res.data;
          let idList = [];
          let idListString = "";
          let nameList = [];
          let nameListString = "";
          res.data.forEach((ele, i) => {
            timeoutIds.forEach((element, index) => {
              if (element === ele.id) {
                idList.push(ele.id);
                nameList.push(ele.realNameAndPhone);
                this.remainUserList.push({
                  id: ele.id,
                  realName: ele.realName,
                  realNameAndPhone: ele.realNameAndPhone,
                });
              }
            });
          });
          if (idList.length > 0) {
            idListString = idList.join(",");
            nameListString = nameList.join(",");
          }
          this.OrderSettingFlowForm.remainUserList = this.deepClone(
            this.remainUserList
          );
          this.OrderSettingFlowForm.timeoutNotifyIds = idListString;
          this.timeoutUserNames = nameListString;
        });
      }


      if (this.OrderSettingFlowForm.evaluateNotifyIds.length > 0) {
        let evaluateNotifyIds =this.OrderSettingFlowForm.evaluateNotifyIds.split(",")

        getUserListByDepartmentId({
          realName: this.realName,
          phone: this.phone,
        }).then((res) => {
          console.log("res getUserListByDepartmentId==>", res);
          this.AllUserList = res.data;
          let idList = [];

          let nameList = [];

          res.data.forEach((ele, i) => {
            evaluateNotifyIds.forEach((element, index) => {
              if (element === ele.id) {
                idList.push(ele.id);
                nameList.push(ele.realNameAndPhone);
                this.choicePeopleOption.selectList.push({
                  id: ele.id,
                  realName: ele.realName,

                });
              }
            });
          });

        });
      }

      // let meals = {
      //     mealA: {a:'7666'},
      //     mealB: 'Lunch',
      //     mealC: 'Dinner'
      // };

      for (let mealName of Object.values(
        this.OrderSettingFlowForm.flowInfoMap
      )) {
        console.log(mealName);
        if (mealName.flowActions) {
          let actionList = [];
          mealName.flowActionsList = mealName.flowActions.split(",");
          mealName.flowActionsList.forEach((element) => {
            if (element) {
              actionList.push({ val: element });
            }
          });
          mealName.flowActionsList = actionList;
        }
        this.orderItemList.push(mealName);
      }

      console.log("this.orderItemList===>", this.orderItemList);
      this.tableData = this.orderItemList;
      let self = this;
      self.tableData = self.tableData.slice(1);
      this.tableData.forEach((ele, index) => {
        // if (ele.workStatus === 5) {
        //   this.tableData[index].timeoutSetting = '挂起超时时间由工单执行人填写';
        // }
        if (ele.flowActions.indexOf(",") == 0) {
          this.tableData[index].flowActions = this.tableData[
            index
          ].flowActions.slice(1);
        }
        // if (parseInt(ele.workStatus)==0) {
        //   console.log('workStatus==================7');
        //   self.tableData.slice(index);
        // }
        if (parseInt(ele.workStatus)==7) {
          console.log('workStatus==================7');
          self.tableData.splice(index,10);
        }
        // if (parseInt(ele.workStatus)==8) {
        //   console.log('workStatus==================8');
        //   self.tableData.splice(index,1)
        // }
        // if (parseInt(ele.workStatus)==9) {
        //   console.log('workStatus==================9');
        //   self.tableData.splice(index,1)
        // }
      });
      if (this.OrderSettingFlowForm.remarkTemplateFlag) {
        // this.OrderSettingFlowForm.remarkTemplateFlag = true;
        this.OrderSettingFlowForm.remarkTemplateFlag_ = true;
      } else {
        // this.OrderSettingFlowForm.remarkTemplateFlag = false;
        this.OrderSettingFlowForm.remarkTemplateFlag_ = false;
      }
      // if (this.OrderSettingFlowForm.remarkTemplateFlag) {
      //   this.OrderSettingFlowForm.remarkTemplateFlag = true;
      // } else {
      //   this.OrderSettingFlowForm.remarkTemplateFlag = false;
      // }
      if (this.OrderSettingFlowForm.positionFlag) {
        this.OrderSettingFlowForm.positionFlag_ = true;
      } else {
        this.OrderSettingFlowForm.positionFlag_ = false;
      }
      if (this.OrderSettingFlowForm.returnVisitFlag) {
        this.OrderSettingFlowForm.returnVisitFlag_ = true;
      } else {
        this.OrderSettingFlowForm.returnVisitFlag_ = false;
      }
       if (this.OrderSettingFlowForm.crossDeptOrderFlag) {
        this.OrderSettingFlowForm.crossDeptOrderFlag_ = true;
      } else {
        this.OrderSettingFlowForm.crossDeptOrderFlag_ = false;
      }
      if (this.OrderSettingFlowForm.crossDeptOrderAuditFlag) {
        this.OrderSettingFlowForm.crossDeptOrderAuditFlag_ = true;
      } else {
        this.OrderSettingFlowForm.crossDeptOrderAuditFlag_ = false;
      }
      if (this.OrderSettingFlowForm.finishConfirmFlag) {
        this.OrderSettingFlowForm.finishConfirmFlag_ = true;
      } else {
        this.OrderSettingFlowForm.finishConfirmFlag_ = false;
      }
      if (this.OrderSettingFlowForm.cancelConfirmFlag) {
        this.OrderSettingFlowForm.cancelConfirmFlag_ = true;
      } else {
        this.OrderSettingFlowForm.cancelConfirmFlag_ = false;
      }
      if (this.OrderSettingFlowForm.startTimeFlag) {
        this.OrderSettingFlowForm.startTimeFlag_ = true;
      } else {
        this.OrderSettingFlowForm.startTimeFlag_ = false;
      }
      this.OrderSettingFlowForm = Object.assign({}, this.OrderSettingFlowForm, {
        positionFlag_: this.OrderSettingFlowForm.positionFlag_,
        remarkTemplateFlag_: this.OrderSettingFlowForm.remarkTemplateFlag_,
        finishConfirmFlag_: this.OrderSettingFlowForm.finishConfirmFlag_,
        cancelConfirmFlag_: this.OrderSettingFlowForm.cancelConfirmFlag_,
        startTimeFlag_: this.OrderSettingFlowForm.startTimeFlag_,
      });
    console.log("this.tableData=======>", this.tableData);
    });
    getTimeoutNotifyStrategy().then((res) => {
      this.timeoutNotifyStrategyList = res.data.data;
    });
    getOrderScoreList().then((res) => {
      this.orderScoreList = res.data.data;
    });
  },
  computed: {},
  methods: {
    transformGetPeople(data){
      let idArry =[]
      data.forEach(item=>{
        idArry.push(item.id)
      })
      let ids = idArry.join(',')
      this.OrderSettingFlowForm.evaluateNotifyIds = ids
    },
    changeTimeoutNotifyWays(valList, index) {
      this.notifyLevelList[index].timeoutNotifyWays_ = valList;

      this.notifyLevelList = this.deepClone(this.notifyLevelList);
    },
    handelNotifyWays(notifyLevelList) {
      this.notifyLevelList.forEach((ele, index) => {
        let NotifyWayIds = ele.timeoutNotifyWays.split(",");
        this.notifyLevelList[index].timeoutNotifyWays_ = NotifyWayIds;
      });
    },
    handelTableUsers(notifyLevelList) {
      getUserListByDepartmentId({
        realName: this.realName,
        phone: this.phone,
      }).then((res) => {
        // console.log(res.data);
        // console.log(res);
        // this.remainUserList = res.data;
        this.AllUserList = res.data;
        this.notifyLevelList.forEach((ele, index) => {
          if (ele.timeoutNotifyUsers && ele.timeoutNotifyUsers.length > 0) {
            let userIds = ele.timeoutNotifyUsers.split(",");
            let userNames = [];
            let remainUserList = [];
            userIds.forEach((ele_, i) => {
              this.AllUserList.forEach((element, index_) => {
                if (ele_ === element.id) {
                  userNames.push(element.realNameAndPhone);
                  remainUserList.push({
                    realName: element.realName,
                    id: element.id,
                    realNameAndPhone: element.realNameAndPhone,
                  });
                }
              });
            });
            this.notifyLevelList[index].remainUserList = remainUserList;

            this.notifyLevelList[index].timeoutUserNames = userNames;
            this.notifyLevelList[index].timeoutUserIds = userIds;
          } else {
            this.notifyLevelList[index].remainUserList = remainUserList;
            this.notifyLevelList[index].timeoutUserNames = [];
            this.notifyLevelList[index].timeoutUserIds = [];
          }
        });
        this.showArriveTimeOutFlag = true;
        console.log("this.notifyLevelList======>", this.notifyLevelList);
      });
    },
    handlerUserForSelect() {
      if (this.OrderSettingFlowForm.timeoutNotifyIds.length > 0) {
        let timeoutIds = [];
        timeoutIds = this.OrderSettingFlowForm.timeoutNotifyIds.split(",");
        getUserListByDepartmentId({
          realName: this.realName,
          phone: this.phone,
        }).then((res) => {
          // console.log(res.data);
          // console.log(res);
          // this.remainUserList = res.data;
          this.AllUserList = res.data;
          let idList = [];
          let idListString = "";
          let nameList = [];
          let nameListString = "";
          this.AllUserList.forEach((ele, i) => {
            timeoutIds.forEach((element, index) => {
              if (element === ele.id) {
                idList.push(ele.id);
                nameList.push(ele.realName);
                this.remainUserList.push({
                  id: ele.id,
                  realName: ele.realName,
                });
              }
            });
          });
          if (idList.length > 0) {
            idListString = idList.join(",");
            nameListString = nameList.join(",");
          }
          this.OrderSettingFlowForm.timeoutNotifyIds = idListString;
          this.timeoutUserNames_ = nameListString;
          console.log(this.timeoutUserNames_);
        });
      }
    },
    addNotifyLevel() {
      this.notifyLevelList.push({});
    },
    delNotifyLevel(index) {
      this.notifyLevelList.splice(index, 1);
    },
    getNotifyWays(val) {
      // console.log(val);p
      let arr = [];
      if (val.wx) {
        arr.push("3");
      }
      if (val.sys) {
        arr.push("1");
      }
      if (val.text) {
        arr.push("2");
      }
      if (arr.length > 1) {
        arr = arr.join(",");
      } else {
        arr = arr.join("");
      }
      return arr;
    },

    getNotifyWays_(val) {
      // console.log(val);
      let arr = [];
      if (val.wx_) {
        arr.push("3");
      }
      if (val.sys_) {
        arr.push("1");
      }
      if (val.text_) {
        arr.push("2");
      }
      if (arr.length > 1) {
        arr = arr.join(",");
      } else {
        arr = arr.join("");
      }
      return arr;
    },

    getWx(list) {
      let flag = false;
      list.split(",").forEach((ele, index) => {
        if (parseInt(ele) == 3) {
          flag = true;
        }
      });
      return flag;
    },
    getSys(list) {
      let flag = false;
      list.split(",").forEach((ele, index) => {
        if (parseInt(ele) == 1) {
          flag = true;
        }
      });
      return flag;
    },
    getText(list) {
      let flag = false;
      list.split(",").forEach((ele, index) => {
        if (parseInt(ele) == 2) {
          flag = true;
        }
      });
      return flag;
    },
    transferBooleanToInt(val) {
      if (val) {
        // if(parseInt(val)>0){
        //     return true;
        // }else{
        //     return false;
        // }
        return 1;
      } else {
        return 0;
      }
    },
    transferBoolean(val) {
      if (val) {
        if (parseInt(val) > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkSelect(checkTagList, validTag) {
      let validBlock = false;
      checkTagList.forEach((ele) => {
        let el = document.querySelector(`div[valid=${ele}]`);

        // let el = document.querySelector(`div[valid=${ele}]`);
        let validValue = el.querySelector("input").value;
        el.querySelector("input").style.border = "";
        if (!validValue) {
          let label = el.attributes.validLabel;
          console.log(label);
          el.querySelector("input").style.border = "1px solid red";
          setTimeout(() => {
            this.$message.error(`"${label.value}"不能为空!`);
          }, 500);
          validBlock = true;
        }
      });
      return validBlock;
    },
    checkInput(checkTagList, validTag) {
      let validBlock = false;
      let re = /^[0-9]+$/;
      checkTagList.forEach((ele) => {
        let el = document.querySelector(`input[valid=${ele}]`);
        let validValue = el.value;
        el.style.border = "";
        if (!validValue) {
          let label = el.attributes.validLabel;
          console.log(label);
          el.style.border = "1px solid red";
          setTimeout(() => {
            this.$message.error(`"${label.value}"不能为空!`);
          }, 500);
          validBlock = true;
        } else if (!re.test(validValue)) {
          if (ele === "timeoutUserNames") {
          } else {
            let label = el.attributes.validLabel;
            console.log(label);
            el.style.border = "1px solid yellow";
            setTimeout(() => {
              this.$message.error(`"${label.value}"格式错误,为正整数!`);
            }, 500);
            validBlock = true;
          }
        }
      });
      return validBlock;
    },
    isPositiveInteger(s) {
      let re = /^[0-9]+$/;
      return re.test(s);
    },
    inputInvalidInputStyle(el) {
      el.style.border = "";
      el.style.border = "1px solid red";
    },
    validTimeoutNumber(val) {
      // console.log(val.target.value);
      // if(!this.timeoutMinuteValid){
      // this.timeoutMinuteValid = this.isPositiveInteger(val.target.value);
      // if(this.timeoutMinuteValid){
      //   this.inputInvalidInputStyle(val.target);
      //   this.$message.error('超时时间请输入正整数!');
      // }else{
      //   val.target.style.border = '';
      // }
      // }
    },
    handleSubmitAction(val) {
      console.log(val);
      console.log("this.dialogIndex=====>", this.dialogIndex);
      if (this.dialogIndex) {
        console.log("this.dialogIndex=====>", this.dialogIndex);
        this.notifyLevelList[this.dialogIndex].timeoutUserNames =
          val.nameListString;
        this.notifyLevelList[this.dialogIndex].timeoutNotifyUsers =
          val.idListString;
        this.notifyLevelList[this.dialogIndex].remainUserList =
          val.dataSelectedUsers;
        console.log("this.remainUserList===>", this.remainUserList);
        this.dialogIndex = "";
      } else {
        this.timeoutUserNames = val.nameListString;
        this.OrderSettingFlowForm.timeoutNotifyIds = val.idListString;
        this.OrderSettingFlowForm.remainUserList = val.dataSelectedUsers;
        console.log(
          "this.remainUserList===>",
          this.OrderSettingFlowForm.remainUserList
        );
      }
      this.dialogUserEditBoxVisible = false;
    },
    handleCloseAction(val) {
      if (this.dialogIndex) {
        this.dialogIndex = "";
      }
      this.dialogUserEditBoxVisible = false;
    },
    addUserBox(type) {
      this.tempProjectId = this.projectId;

      this.handleAction = 1;
      this.selectUserType = 1;
      console.log();
      this.remainUserList = this.OrderSettingFlowForm.remainUserList
        ? this.OrderSettingFlowForm.remainUserList
        : [];
      if (type == 1) {
      } else {
      }

      this.dialogUserEditBoxVisible = true;
    },

    //工单到场超时层级推送设置-人员选择
    addUserBox_(item, index) {
      console.log("item==> addUserBox_", item);
      this.tempProjectId = this.projectId;
      this.handleAction = 1;
      this.selectUserType = 1;
      this.remainUserList = item.remainUserList ? item.remainUserList : [];
      this.dialogIndex = index + "";
      this.dialogUserEditBoxVisible = true;
    },

    closeUserDialog() {
      console.log("closeUserDialog");
      if (this.dialogIndex) {
        this.dialogIndex = "";
      }
      this.dialogUserEditBoxVisible = false;
    },

    closeDialog() {
      this.$emit("closeDialog");
    },
    getAuditNotifyHandler() {
      this.OrderSettingFlowForm.auditResultNotifyFlag = this.transferBooleanToInt(
        this.OrderSettingFlowForm.auditResultNotifyFlag_
      );
      this.OrderSettingFlowForm.auditNotifyFlag = this.transferBooleanToInt(
        this.OrderSettingFlowForm.auditNotifyFlag_
      );
      this.OrderSettingFlowForm.auditNotifyWays = this.getNotifyWays(
        this.OrderSettingFlowForm
      );
      this.OrderSettingFlowForm.auditResultNotifyWays = this.getNotifyWays_(
        this.OrderSettingFlowForm
      );
    },
    getFormFlowFlag() {
      if (this.OrderSettingFlowForm.remarkTemplateFlag_) {
        this.OrderSettingFlowForm.remarkTemplateFlag = 1;
      } else {
        this.OrderSettingFlowForm.remarkTemplateFlag = 0;
      }

      if (this.OrderSettingFlowForm.positionFlag_) {
        this.OrderSettingFlowForm.positionFlag = 1;
      } else {
        this.OrderSettingFlowForm.positionFlag = 0;
      }
      if (this.OrderSettingFlowForm.finishConfirmFlag_) {
        this.OrderSettingFlowForm.finishConfirmFlag = 1;
      } else {
        this.OrderSettingFlowForm.finishConfirmFlag = 0;
      }
      if (this.OrderSettingFlowForm.cancelConfirmFlag_) {
        this.OrderSettingFlowForm.cancelConfirmFlag = 1;
      } else {
        this.OrderSettingFlowForm.cancelConfirmFlag = 0;
      }
      if (this.OrderSettingFlowForm.startTimeFlag_) {
        this.OrderSettingFlowForm.startTimeFlag = 1;
      } else {
        this.OrderSettingFlowForm.startTimeFlag = 0;
      }
      if (this.OrderSettingFlowForm.returnVisitFlag_) {
        this.OrderSettingFlowForm.returnVisitFlag = 1;
      } else {
        this.OrderSettingFlowForm.returnVisitFlag = 0;
      }
      if (this.OrderSettingFlowForm.crossDeptOrderFlag_) {
        this.OrderSettingFlowForm.crossDeptOrderFlag = 1;
      } else {
        this.OrderSettingFlowForm.crossDeptOrderFlag = 0;
      }
       if (this.OrderSettingFlowForm.crossDeptOrderAuditFlag_) {
        this.OrderSettingFlowForm.crossDeptOrderAuditFlag = 1;
      } else {
        this.OrderSettingFlowForm.crossDeptOrderAuditFlag = 0;
      }
    },
    validFormData() {
      let validNullBlock = false;
      let validBlock = false;
      let eleList = document.querySelectorAll('input[valid="timeoutSetting"]');
      let numberPlus = /^[0-9]+$/;

      console.log("eleList====>", eleList);
      eleList.forEach((ele, index) => {
        ele.style.border = "";
        if (!ele.value) {
          ele.style.border = "1px solid red";
          validNullBlock = true;
        } else if (!numberPlus.test(ele.value)) {
          ele.style.border = "1px solid yellow";
          validBlock = true;
        }
      });
      let selectCheckList = [
        "evaluateReturnVisitScore",
        "evaluateDefaultScore",
        "timeoutNotifyStrategy",
      ];

      let inputCheckList = [
        "timeoutNotifyRadius",
        "evaluateTimeoutNum",
        // "defaultStartDelay"
      ];

      let selectValid = this.checkSelect(selectCheckList);
      let inputValid = this.checkInput(inputCheckList);



      let validFlag = false;
      let validNullFlag = false;
      let eleList_ = document.querySelectorAll("input[name=timeOut]");
      eleList_.forEach((ele,index)=>{
        ele.style.border ="";
        console.log("timeoutEle========>",ele.value);
        if(!ele.value){
          ele.style.border ="1px solid red";
          validNullFlag = true;
        }else if(ele.value&&(Number(ele.value)+'')==='NaN'){
          ele.style.border ="1px solid red";
          validFlag = true;
        }
      });
      // return validFlag;
      console.log("validFlag==================>",validFlag);


      if (validNullFlag) {
        this.$message.error('"超时设置"不能为空!');
        return true;
      }
      if (validFlag) {
        this.$message.error('"超时设置"格式为正整数!');
        return true;
      }

      if (validNullBlock) {
        this.$message.error('"超时设置"不能为空!');
        return true;
      }
      if (validBlock) {
        this.$message.error('"超时设置"格式为正整数!');
        return true;
      }
      if (selectValid) {
        // this.$message.error('"超时设置"不能为空!');
        return true;
      }
      if (inputValid) {
        // this.$message.error('"超时设置"格式为正整数!');
        return true;
      }

     /* if(this.OrderSettingFlowForm.grabSingleMaxNum){
        if(!numberPlus.test(this.OrderSettingFlowForm.grabSingleMaxNum)){
          this.$message.error('"抢单最大工单数设置"格式为正整数!');
          return true;
        }
      }*/
      // if (
      //   !this.OrderSettingFlowForm.systemNotifyWays_ ||
      //   this.OrderSettingFlowForm.systemNotifyWays_.length == 0
      // ) {
      //   this.$message.error('请选择"通知方式"!');
      //   document.querySelector("input[name=systemNotifyWays]").style.border =
      //     "1px solid red";
      //   return true;
      // }
    },
    validTimeOut(){
    },
    submitAllFlowData() {
      console.log(this.OrderSettingFlowForm.flowInfoMap);

      this.OrderSettingFlowForm.autoConfirmDays = this.OrderSettingFlowForm.finishConfirmFlag_?Number(this.OrderSettingFlowForm.autoConfirmDays):0
      document.querySelector("input[name=systemNotifyWays]").style.border = "";

      this.getAuditNotifyHandler();

      this.getFormFlowFlag();

      this.getFlowInfoMap();

      if (this.getNotifyLevelList()) {
        return;
      }
      if (this.validFormData()) {
        return;
      }
      if(this.OrderSettingFlowForm.systemNotifyWays_){
        this.OrderSettingFlowForm.systemNotifyWays = this.OrderSettingFlowForm.systemNotifyWays_.join(
          ","
        );
      }
      if(this.OrderSettingFlowForm.evaluateNotifyWays_){
        this.OrderSettingFlowForm.evaluateNotifyWays = this.OrderSettingFlowForm.evaluateNotifyWays_.join(
          ","
        );
      }
      // console.log("this.OrderSettingFlowForm====>",this.OrderSettingFlowForm);
      // return;
      saveOrderSettingFlow(this.OrderSettingFlowForm).then((res) => {
        this.$emit("closeDialog");
      });
    },

    getNotifyLevelList() {
      let validNotifyLevelList = false;
      if (this.notifyLevelList && this.notifyLevelList.length > 0) {
        this.notifyLevelList.forEach((ele, index) => {
          if (JSON.stringify(ele).indexOf("{}") > -1) {
            validNotifyLevelList = true;
          } else {
            if (ele.timeoutNotifyWays_ && ele.timeoutNotifyWays_.length > 0) {
              this.notifyLevelList[
                index
              ].timeoutNotifyWays = ele.timeoutNotifyWays_.join(",");
            } else {
              this.notifyLevelList[index].timeoutNotifyWays = "";
            }
            if (!ele.timeoutNotifyWays) {
              validNotifyLevelList = true;
            }
            if (!ele.timeoutRadius) {
              validNotifyLevelList = true;
            }
            if (!ele.timeoutNotifyUsers) {
              validNotifyLevelList = true;
            }
            if (!ele.timeoutStrategy) {
              validNotifyLevelList = true;
            }
            // for (let mealName of Object.keys(ele)) {
            //   // console.log(mealName);
            //   // if(mealName === 'timeoutStrategy'||'timeoutRadius'||'timeoutNotifyUsers'||'timeoutNotifyWays_'){
            //   //   console.log(mealName);
            //   //     validNotifyLevelList = true;
            //   // }
            //   if(ele[mealName]==='timeoutStrategy'){

            //   }
            //   if(ele[mealName]==='timeoutRadius'){

            //   }
            //   if(ele[mealName]==='timeoutNotifyUsers'){

            //   }
            //   if(ele[mealName]==='timeoutNotifyWays_'){
            //     if(){

            //     }
            //   }
            // }
          }
        });
      } else {
        this.notifyLevelList = [];
      }
      this.OrderSettingFlowForm.notifyLevelList = this.notifyLevelList;
      if (validNotifyLevelList) {
        this.$message.error('"工单到场超时层级推送设置"列表项填写不完整!');
      }
      return validNotifyLevelList;
    },
    getFlowInfoMap() {
      this.OrderSettingFlowForm.flowInfoMap = {};
      this.orderItemList.forEach((ele, index) => {
        if (index > 9) {
          return;
        } else {
          this.OrderSettingFlowForm.flowInfoMap[index] = ele;
          // if(index==5){
          //   this.OrderSettingFlowForm.flowInfoMap[index].timeoutSetting = '';
          // }
        }
      });
      console.log(this.OrderSettingFlowForm.flowInfoMap);
    },
    getTimeoutShow(val) {
      // return !(val === 1 || val === 5 || val === 7 || val === 8);
      // if(val === 5){
      //   return '挂起超时时间由工单执行人填写'
      // }
      return !(val === 5 || val === 7 || val === 8);
    },
    getOrderSettingFlow(val,row) {
      switch (val) {
        case 0:
          return "需求人员新建工单";
        case 1:
          // return "需求人员新建工单，状态为【待指派】";
          return "工单待指派状态，超过"+row.timeoutSetting+"分钟，还没有进行派单/抢单操作";
        case 2:
          return "工单已指派状态，超过"+row.timeoutSetting+"分钟，还没有进行接受/转办/协同操作";
        case 3:
          return "工单已接受状态，超过"+row.timeoutSetting+"分钟，还没有进行开始/转办/协同操作";
        case 4:
          return "工单进行中状态，超过"+row.timeoutSetting+"分钟，还没有进行完成/转办/协同/挂起/外委操作";
        case 5:
          return "工单挂起状态，超过"+row.timeoutSetting+"分钟，还没有进行恢复操作";
        case 6:
          return "工单待验收状态，超过"+row.timeoutSetting+"分钟，还没有进行验收操作";
        case 7:
          return "工单执行人完成工单，状态为【已完成】";
        case 8:
          return "工单闭环，状态为【已关闭】";
        case 9:
          return "如果完成前工单被取消，状态为【已取消】";
        default:
          break;
      }
    },
    getOrderStatusName(val) {
      switch (val) {
        case 0:
          return "待受理";
        case 1:
          return "待指派";
        case 2:
          return "已指派";
        case 3:
          return "已接受";
        case 4:
          return "进行中";
        case 5:
          return "挂起";
        case 6:
          return "待验收";
        case 7:
          return "完成工单";
        case 8:
          return "关闭工单";
        case 9:
          return "取消工单";
        default:
          break;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1px);
  max-width: calc(100% - 30px);
}
 ::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
